// src/store/categoryOptions/slice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FieldOption } from "../../../layouts/UniversalField/UniversalField";

type CategoryOptionsState = {
  [categoryId: string]: {
    [fieldId: string]: FieldOption[];
  };
};

const initialState: CategoryOptionsState = {};

const categoryOptionsSlice = createSlice({
  name: "categoryOptions",
  initialState,
  reducers: {
    setFieldOptions: (
      state,
      action: PayloadAction<{
        categoryId: string;
        fieldId: string;
        options: FieldOption[];
      }>,
    ) => {
      const { categoryId, fieldId, options } = action.payload;
      state[categoryId] ??= {};
      state[categoryId][fieldId] = options;
    },
    clearCategoryOptions: (
      state,
      action: PayloadAction<{ categoryId: string }>,
    ) => {
      delete state[action.payload.categoryId];
    },
    // fetchFieldOptionsRequest: (
    //   state,
    //   action: PayloadAction<{ categoryId: string; fieldId: string; apiEndpoint: string }>
    // ) => {
    //   // This will be handled by saga
    // },
  },
});

export const { setFieldOptions, clearCategoryOptions } =
  categoryOptionsSlice.actions;
export default categoryOptionsSlice.reducer;

// selector helper
export const selectFieldOptions = (
  state: any,
  categoryId: string,
  fieldId: string,
) => state.categoryOptions?.[categoryId]?.[fieldId] ?? [];
